import React, { useEffect } from 'react';
import { IonContent, IonHeader, IonItem, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import '../components/ExploreContainer.css';
import './Style.css';
import './Slick.css';
import './Home.css';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Footer from './Footer';
import Header from './Header';

const ClassNames = [
    { id: "nursery", name: 'Nursery' },
    { id: "lkg", name: 'LKG' },
    { id: "ukg", name: 'UKG' },
    { id: "class-one", name: 'Class 1' },
    { id: "class-two", name: 'Class 2' },
];


const Home: React.FC = () => {

    useEffect(() => {
        document.title = "Mamas Guidance - An Educational Platform for Kids"; // Set page title
    }, []);
    return (
        <IonPage>
            <IonContent fullscreen>
                <Header />
                <section className="slider-area ">
                    <div className="slider-active slick-initialized slick-slider">

                        <div className="slick-list draggable">
                            <div className="slick-track" style={{ 'opacity': '1', 'width': '100%' }}>
                                <div className="single-slider slider-height d-flex align-items-center slick-slide slick-current slick-active" style={{ 'width': '100%', 'position': 'relative', 'left': '0px', 'top': '0px', zIndex: '999', 'opacity': '1' }} data-slick-index="0" aria-hidden="false">
                                    {/* <div className="container">
                                        <div className="row">
                                            <div className="col-xl-5 col-lg-7 col-md-10 col-sm-11">
                                                <div className="hero__caption">
                                                    <h1 data-animation="fadeInLeft" data-delay="0.2s" className="" style={{ animationDelay: '0.2s' }}>Quality<br /> Learning</h1>
                                                    <span data-animation="fadeInLeft" data-delay="0.4s" className="" style={{ animationDelay: '0.4s' }}>For Every Child</span>
                                                    <a href="#classes" className="btn hero-btn" data-animation="fadeInLeft" data-delay="0.7s" style={{ animationDelay: '0.7s', color: "#FFF" }}>Explore Classes</a>
                                                </div>
                                            </div>
                                            <div className="col-xl-7 col-lg-5 col-md-2 col-sm-1"></div>
                                        </div>
                                    </div> */}
                                    <Swiper
                                        modules={[Autoplay, Pagination]}
                                        spaceBetween={20}
                                        slidesPerView={1}
                                        autoplay={{
                                            delay: 5000,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{ clickable: true }}
                                        loop={false}
                                    >
                                        <SwiperSlide><img src="/assets/banner6.avif" alt="Slide 1" style={{ height: "50%" }} /></SwiperSlide>
                                        <SwiperSlide><img src="/assets/banner1.avif" alt="Slide 1" /></SwiperSlide>
                                        <SwiperSlide><img src="/assets/banner3.avif" alt="Slide 3" /></SwiperSlide>
                                        <SwiperSlide><img src="/assets/banner2.avif" alt="Slide 2" /></SwiperSlide>
                                        <SwiperSlide><img src="/assets/banner4.avif" alt="Slide 4" /></SwiperSlide>
                                        <SwiperSlide><img src="/assets/banner5.avif" alt="Slide 5" /></SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <div className="svgPart"><svg width="100%" height="70" viewBox="0 0 100 100" preserveAspectRatio="none" style={{ backgroundColor: '#fef4dd' }}><path id="wavepath" d="M0,0  L110,0C35,150 35,0 0,100z" fill="#0c706d"></path></svg></div> */}

                <div className="about-low-area section-padding40" style={{ paddingBottom: "0" }} id='about'>
                    <div className="mt-5 container">
                        <div className="row justify-content-center">
                            <div className="col-xl-10 col-lg-10 col-md-10 col-sm-11">
                                <div className="section-tittle text-center mb-70">
                                    <h2>Welcome to <span>Mamas Guidance</span></h2>
                                    <p><strong>Learning</strong> is a journey, not a race. Every child grows at their own pace, and the path to understanding is filled with exploration, mistakes, and small victories. By supporting your child with love, patience, and encouragement, you’re not just helping them master subjects—you’re building their <b><em>confidence, curiosity, and resilience</em></b>. Celebrate their efforts, not just their results, and create a safe space where they feel excited to try, fail, and try again. This positive learning environment lays a strong foundation for lifelong success, emotional well-being, and a love for learning that will stay with them forever.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="olympiad-section">
                    <div className="olympiad-header">
                        <h2>🌟 Olympiad Zone – Unlock Your Child’s Potential!</h2>
                        <p>Prepare for IMO, NSO, IEO, NCO, IGKO with structured, fun, and smart learning resources.</p>
                    </div>

                    <div className="olympiad-grid">
                        <div className="olympiad-card imo">
                            <h3>📐 IMO</h3>
                            <p>Math Olympiad practice for Class 1 & 2</p>
                            <Link to="/imo" >Start Now</Link>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>🔬 NSO</h3>
                            <p>Science Olympiad made easy and fun</p>
                            <Link to="/nso">Start Now</Link>
                        </div>
                        <div className="olympiad-card ieo">
                            <h3>🗣️ IEO</h3>
                            <p>Build English skills with Olympiad sets</p>
                            <Link to="/ieo">Start Now</Link>
                        </div>
                    </div>

                    <div className="olympiad-footer">
                        <p>Want your child to ace Olympiads with confidence?</p>
                        <Link to="/all-olympiads">Explore All Olympiads</Link>
                    </div>
                </section>

                <div className="about-low-area section-padding40" id='we-offer'>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-10 col-lg-10 col-md-10 col-sm-11">
                                <div className="section-tittle text-center mb-70">
                                    <h2 style={{ color: '#e68b13' }}>What We Offer</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center">
                            <div className="col-lg-7 col-md-12">
                                <div className="about-caption">
                                    <div className="single-features mb-30">
                                        <div className="features-icon">
                                            <img src="assets/about-icon1.avif" alt="" />
                                        </div>
                                        <div className="features-caption">
                                            <h3 className="color-font1">Extensive Worksheet Collection</h3>
                                            <p>At <b>Mama’s Guidance</b>, we believe in making learning engaging, effective, and fun. Our Extensive Worksheet Collection is thoughtfully designed to help children from Nursery build strong foundational skills across subjects.</p>
                                        </div>
                                    </div>
                                    <div className="single-features mb-30">
                                        <div className="features-icon">
                                            <img src="assets/about-icon2.avif" alt="" />
                                        </div>
                                        <div className="features-caption">
                                            <h3 className="color-font2">Massive Question Bank</h3>
                                            <p>Give your child access to over <b>10,000 practice questions</b> designed to boost their knowledge and confidence. Your ultimate destination for comprehensive practice questions designed especially for young learners. </p>
                                        </div>
                                    </div>

                                    <div className="single-features mb-30">
                                        <div className="features-icon">
                                            <img src="assets/about-icon3.avif" alt="" />
                                        </div>
                                        <div className="features-caption">
                                            <h3 className="color-font3">Engaging & Interactive Learning</h3>
                                            <p>At <b>Mama’s Guidance</b>, we understand that young children learn best when they’re having fun. That’s why we bring you a unique blend of interactive, playful, and hands-on learning experiences designed for curious minds from LKG to Class 2.</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12">
                                <div className="about-img ">
                                    <img src="assets/about_2.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="svgPart"><svg width="100%" height="70" viewBox="0 0 100 100" preserveAspectRatio="none" style={{ backgroundColor: '#0c706d' }}><path id="wavepath" d="M0,0  L110,0C35,150 35,0 0,100z" fill="#fef4dd"></path></svg></div> */}

                {/* <section className="contact-section" id='classes' style={{ backgroundColor: '#0c706d' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-10 col-lg-10 col-md-10 col-sm-11">
                                <div className="section-tittle text-center mb-70">
                                    <h2 style={{ color: '#e68b13' }}>Choose Classes</h2>
                                </div>
                            </div>
                        </div>
                        <div className={`my-topic-container homePage`} style={{ height: 'auto', display: "grid" }}>
                            {ClassNames.map((slide, index) => (
                                <div key={slide.id} className="my-topic">
                                    <IonItem className='chooseClass' key={index} routerLink={slide.id}
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <h4 className="card-content">{slide.name}</h4>
                                    </IonItem>
                                </div>
                            ))}
                        </div>
                    </div>
                </section> */}
                <section className="classes-section">
                    <div className="classes-header">
                        <h2>🎓 Explore Learning by Class</h2>
                        <p>Select your child’s class to access worksheets, quizzes, and Olympiad practice.</p>
                    </div>

                    <div className="classes-grid">
                        <div className="class-card lkg">
                            <h3>🧸 Nursery</h3>
                            <p>Early concepts, fun learning.</p>
                            <Link to="/nursery">Explore Nursery</Link>
                        </div>
                        <div className="class-card lkg">
                            <h3>🧸 LKG</h3>
                            <p>Spark curiosity and build strong early learning foundations.</p>
                            <Link to="/lkg">Explore LKG</Link>
                        </div>

                        <div className="class-card ukg">
                            <h3>🎈 UKG</h3>
                            <p>Hands-on learning with games, stories, and practice.</p>
                            <Link to="/ukg">Explore UKG</Link>
                        </div>

                        <div className="class-card class1">
                            <h3>📘 Class 1</h3>
                            <p>Structured topics, Olympiad prep, and reasoning skills.</p>
                            <Link to="/class-one">Explore Class 1</Link>
                        </div>

                        <div className="class-card class2">
                            <h3>📗 Class 2</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-two">Explore Class 2</Link>
                        </div>

                        <div className="class-card class3">
                            <h3>📕 Class 3</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-three">Explore Class 3</Link>
                        </div>

                        <div className="class-card class4">
                            <h3>📙 Class 4</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-four">Explore Class 4</Link>
                        </div>

                        <div className="class-card class5">
                            <h3>📔 Class 5</h3>
                            <p>Advanced practice, logic-building, and exam prep tools.</p>
                            <Link to="/class-five">Explore Class 5</Link>
                        </div>
                    </div>


                </section>

                {/* <div className="svgPart"><svg width="100%" height="70" viewBox="0 0 100 100" preserveAspectRatio="none" style={{ backgroundColor: '#fef4dd' }}><path id="wavepath" d="M0,0  L110,0C35,150 35,0 0,100z" fill="#0c706d"></path></svg></div> */}
                {/* <footer id="contact">
                    <div className="footer-wrappper footer-bg">
                        <div className="footer-area ">
                            <div className="container">
                                <div className="row justify-content-between">
                                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-8">
                                        <div className="single-footer-caption mb-50">
                                            <div className="single-footer-caption mb-30">
                                                <div className="footer-logo mb-25">
                                                    <a href="/"><img src="assets/logo-500.png" style={{ height: '200px' }} alt="" /></a>
                                                </div>
                                                <div className="footer-tittle">
                                                    <div className="footer-pera">
                                                        <p><strong>Mamas Guidance</strong> is an innovative platform designed to nurture young minds by providing them with <strong>engaging</strong> and <strong>effective learning experiences</strong>. Our mission is to make education <strong>enjoyable</strong>, <strong>accessible</strong>, and <strong>impactful</strong> for children of all ages.</p>
                                                    </div>
                                                </div>
                                                <div className="footer-social">
                                                    <a href="https://x.com/MamasGuidance" target='_blank' rel="noreferrer" aria-label="Visit our Twitter profile"><i className="fab fa-twitter"></i></a>
                                                    <a href="https://www.facebook.com/profile.php?id=61577840330706" target='_blank' rel="noreferrer" aria-label="Visit our Facebook profile"><i className="fab fa-facebook-f"></i></a>
                                                    <a href="https://www.youtube.com/channel/UCCAToEWU7aJAVOlTlEX_6XA" target='_blank' rel="noreferrer" aria-label="Visit our Youtube channel"><i className="fab fa-youtube"></i></a>
                                                    <a href="https://www.instagram.com/mamas.guidance/" target='_blank' rel="noreferrer" aria-label="Visit our Instagram profile"><i className="fab fa-instagram"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-10">
                                        <div className="row" style={{ marginTop: '100px' }}>
                                            <div className="col-12">
                                                <h2 className="contact-title" style={{ color: '#0c706d' }}>Get in Touch</h2>
                                            </div>
                                            <div className="media contact-info">
                                                <span className="contact-info__icon"><i className="ti-email"></i></span>
                                                <div className="media-body">
                                                    <h3><strong>support@mamasguidance.com</strong></h3>
                                                    <p>Send us your query anytime!</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-bottom-area" style={{ background: "rgb(12, 112, 109)" }}>
                            <div className="container">
                                <div className="footer-border">
                                    <div className="row d-flex align-items-center">
                                        <div className="col-xl-12 ">
                                            <div className="footer-copy-right text-center">
                                                <p>Copyright ©<script type="text/javascript" src="https://www.google-analytics.com/analytics.js"></script><script>document.write(new Date().getFullYear());</script>2025 All rights reserved.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer> */}
                <Footer />

            </IonContent>
        </IonPage >
    );
};

export default Home;
